export const SET_TASKUPDATINGS = 'TaskUpdatings/set';
export const SET_TASKUPDATINGS_UPDATED = 'TaskUpdatings/UpdateStatus/set';
